'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _reduxActions = require('redux-actions');

var _IndexedAsyncData = require('conversations-async-data/indexed-async-data/IndexedAsyncData');

var _IndexedAsyncData2 = _interopRequireDefault(_IndexedAsyncData);

var _AsyncData = require('conversations-async-data/async-data/AsyncData');

var _AsyncData2 = _interopRequireDefault(_AsyncData);

var _requestStartedWithOperator = require('conversations-async-data/async-data/operators/requestStartedWithOperator');

var _requestFailedWithOperator = require('conversations-async-data/async-data/operators/requestFailedWithOperator');

var _updateEntry = require('conversations-async-data/indexed-async-data/operators/updateEntry');

var _deleteEntry = require('conversations-async-data/indexed-async-data/operators/deleteEntry');

var _makeRequestActionTypes = require('conversations-internal-clients/action-creators/operators/makeRequestActionTypes');

var _messageKeyInvariant = require('conversations-schema/invariants/messageKeyInvariant');

var _ActivelyPublishing = require('conversations-schema/unpublished-messages/records/ActivelyPublishing');

var _ActivelyPublishing2 = _interopRequireDefault(_ActivelyPublishing);

var _FailedToPublish = require('conversations-schema/unpublished-messages/records/FailedToPublish');

var _FailedToPublish2 = _interopRequireDefault(_FailedToPublish);

var _asyncActionTypes = require('../constants/asyncActionTypes');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PUBLISH_MESSAGE = (0, _makeRequestActionTypes.makeRequestActionTypes)(_asyncActionTypes.PUBLISH_MESSAGE);

var initialState = (0, _IndexedAsyncData2.default)({
  notSetValue: (0, _AsyncData2.default)({ data: null }),
  // TODO CMF; replace with a proper id invariant
  idTransform: function idTransform(id) {
    return id;
  },
  idInvariant: _messageKeyInvariant.messageKeyInvariant
});

exports.default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, PUBLISH_MESSAGE.STARTED, function (state, action) {
  var _action$payload = action.payload,
      messageKey = _action$payload.messageKey,
      threadId = _action$payload.threadId,
      channel = _action$payload.channel,
      message = _action$payload.message;

  return (0, _updateEntry.updateEntry)(messageKey, (0, _requestStartedWithOperator.requestStartedWithOperator)(function () {
    return (0, _ActivelyPublishing2.default)({ threadId: threadId, channel: channel, message: message });
  }), state);
}), _defineProperty(_handleActions, PUBLISH_MESSAGE.SUCCEEDED, function (state, action) {
  var messageKey = action.payload.messageKey;

  return (0, _deleteEntry.deleteEntry)(messageKey, state);
}), _defineProperty(_handleActions, PUBLISH_MESSAGE.FAILED, function (state, action) {
  var _action$payload2 = action.payload,
      messageKey = _action$payload2.messageKey,
      threadId = _action$payload2.threadId,
      channel = _action$payload2.channel,
      message = _action$payload2.message;

  return (0, _updateEntry.updateEntry)(messageKey, (0, _requestFailedWithOperator.requestFailedWithOperator)(function () {
    return (0, _FailedToPublish2.default)({ threadId: threadId, channel: channel, message: message });
  }), state);
}), _handleActions), initialState);
module.exports = exports['default'];